import * as React from 'react';
import Project from 'src/entities/Project';
import DocumentContractMiniatureContainer from './partials/DocumentContractMiniature.container';
import Investment from 'src/entities/Investment';

interface Props {
  project: Project;
  investment: Investment;
}

const SignContractsComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="col-sm-12">
    <div className="padding-left-30">
      <div className="gap-50"/>
      <div className="row">
        <div
          className="col-md-6 fa-align-center"
        >
          <p className="jobTitle">
            Acuerdo de sindicación:
          </p>

          <DocumentContractMiniatureContainer
            typeDocument={true}
            active={props.investment.signedSyndicateAgreement!}
            documentFile={props.project.syndicateAgreement!}
            imageFile={props.project.syndicateAgreementImage ? props.project.syndicateAgreementImage!.url! : undefined}
          />
        </div>
        <div
          className="col-md-6 fa-align-center"
        >
          <p className="jobTitle">
            Pacto de socios:
          </p>
          <DocumentContractMiniatureContainer
            typeDocument={false}
            active={props.investment.signedShareholderAgreement!}
            documentFile={props.project.stakeholderAgreement!}
            imageFile={props.project.stakeholderAgreementImage ?
              props.project.stakeholderAgreementImage!.url! : undefined}
          />
        </div>
      </div>
      <div className="gap-50"/>
      <div className="row">
        <div className="col-sm-12 padding-left-60">
          <p>
            Ahora continuaremos con la firma de los contratos.
            Para ello te hemos enviado una solicitud por cada documento directamente a tu
            correo electrónico desde nuestra plataforma de firmas online Signaturit.
          </p>
          <div className="gap-20"/>
          <p>
            Si no has recibido los emails, te recomendamos que revises tu bandeja de
            “Correo no deseado” para confirmar su recepción.
            Y si todavía no los encuentras, por favor escríbenos a investors@thecrowdangel.com
          </p>
          <div className="gap-20"/>
          <p>
            <small>
              *No necesitas descargar ninguna aplicación ni extensión en tu ordenador,
              simplemente recibirás un correo con un enlace al documento a firmar y
              las instrucciones para realizarlo.
            </small>
          </p>
          <div className="gap-20"/>
        </div>
      </div>
    </div>
  </div>
);

export default SignContractsComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/sign-contracts/SignContracts.component.tsx